import OpapWebhookOverview from '@/modules/integrations/types/opapwebhook/OpapWebhookOverview'
import OpapWebhookSettings from '@/modules/integrations/types/opapwebhook/OpapWebhookSettings'

export default Object.freeze({
  type: 'opapwebhook',
  title: 'Integrations_Opap_Webhook',
  category: 'Integrations_Opap_Webhook_Category',
  description: 'Integrations_Opap_Webhook_Description',
  image: require('@/img/integrations/opap-webhook.png'),
  requiresAdmin: false,
  components: {
    overview: OpapWebhookOverview,
    settings: OpapWebhookSettings
  },
  urls: {
    guide: 'https://docs.xtremepush.com/docs/webhooks-opap'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/opapwebhook/index.js